import AuthMixin from "basis/views/auth/mixin.vue";
import AuthFoxONE from "basis/views/auth/foxone.vue";
import Login from "basis/views/login.vue";
import Profile from "basis/views/profile.vue";

const routes = [
  {
    path: "/auth/mixin",
    name: "auth-mixin",
    component: AuthMixin
  },
  {
    path: "/auth/foxone",
    name: "auth-foxone",
    component: AuthFoxONE
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/settings",
    name: "settings",
    component: () => import("basis/views/settings.vue")
  },
  {
    path: "/mine",
    name: "mine",
    component: () => import("basis/views/mine.vue")
  },
  {
    path: "/debug",
    name: "debug",
    component: () => import("basis/views/debug.vue")
  },
  {
    path: "/invite",
    name: "invite",
    component: () => import("basis/views/invite.vue")
  },
  {
    path: "/mine_invite",
    name: "mine_invite",
    component: () => import("basis/views/mine_invite.vue")
  },
  {
    path: "/survey",
    name: "survey",
    component: () => import("basis/views/survey/index.vue")
  },
  {
    path: "/survey/quiz",
    name: "survey-quiz",
    component: () => import("basis/views/survey/quiz.vue")
  },
  {
    path: "/survey/result",
    name: "survey-result",
    component: () => import("basis/views/survey/result.vue")
  },
  {
    path: "/tools",
    name: "tools",
    component: () => import("basis/views/tools.vue")
  },
  {
    path: "/tools/box_decompose",
    name: "tools-box_decompose",
    component: () => import("basis/views/tools/box_decompose.vue")
  },
  {
    path: "/kyc",
    name: "kyc",
    component: () => import("basis/views/kyc/index.vue")
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile
  }
];

export default routes;
